module.exports = __webpack_public_path__ + "static/media/06C.3da22f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/06C.png
// module id = 281
// module chunks = 0